import { OverlayScrollbars } from 'overlayscrollbars';

let osInstance = null;

document.addEventListener('DOMContentLoaded', () => {
    const path = window.location.pathname.replace(/\/$/, '');
    if (path !== '/forms') {
        const frontBody = document.querySelector('html.front-end body');
        if (frontBody) {
            osInstance = OverlayScrollbars(frontBody, {
                scrollbars: {
                    autoHide: 'never',
                },
            });
        }
    }
});

export const getOsInstance = () => osInstance;
export const setOsInstance = ( instance ) => {
  osInstance = instance;
};

export const killBodyScroll = () => {
  const osInstance = getOsInstance();
  if ( osInstance ) {
    osInstance.destroy();
    setOsInstance( null );
    document.body.style.overflow = 'hidden'; // Block scrolling by setting overflow to hidden
  }
};

export const initBodyScroll = () => {
  document.body.style.overflow = ''; // Remove the overflow hidden style to enable scrolling
  const frontHtml = document.querySelector( 'html.front-end body' );
  if ( frontHtml ) {
    const newInstance = OverlayScrollbars( frontHtml, {
      scrollbars: {
        autoHide: 'never',
      },
    } );
    setOsInstance( newInstance );
  }
};
